<template>
    <div class="home-analytics">
        <GrafanaIframe :url="homeAnalyticsUrl" title="Home Analytics Dashboard" />
    </div>
</template>

<script lang="ts" setup>
import GrafanaIframe from '@/components/GrafanaIframe.vue'
import { useBreadCrumbsStore } from '@/stores/breadCrumbs'
import { computed, onMounted } from 'vue'

const breadCrumbsStore = useBreadCrumbsStore()
const homeAnalyticsUrl = computed(() => {
    return import.meta.env.VITE_ANALYTICS_HOME_URL
})

onMounted(() => {
    breadCrumbsStore.$patch({
        items: [
            {
                text: `Home`
            }
        ]
    })
})
</script>

<style lang="scss" scoped>
.home-analytics {
    height: 100%;
    min-height: 0; // Allows flex child to shrink below content size when parent is a flex container
}
</style>
